(function (window, document, $, undefined) {
    'use strict';

    window.forms = {};

    forms.init = function () {
        forms.noCopy();
    };

    forms.noCopy = function () {
        $('.no-copy-paste').on('copy paste cut', function (e) {
            e.preventDefault(); //disable cut,copy,paste

            return false;
        });
        $('.no-copy-paste').bind('contextmenu', function () {
            return false;
        });
    };

    $(document).on('ready', forms.init);
})(window, document, jQuery);

jQuery(document).on('gform_post_render', function (event, form_id, current_page) {

    // Calculator Form fixes
    $(".gf_readonly input").attr("readonly","readonly");
    //convertNumberInput();

    // Community Forms
    hideProductSelection();

    $('#input_13_12_5, #input_13_34_5').attr('maxlength', '5');
    var formUtility = $('input[name="input_32"]:checked').val() ? $('input[name="input_32"]:checked').val() : '';

    if (formUtility === 'Eversource West' || formUtility === 'Eversource') {
        eversource_west_settings();
    }

    if (formUtility === 'Eversource East') {
        eversource_east_settings();
    }

    if (formUtility === 'National Grid') {
        national_grid_settings();
    }

    if (formUtility === 'Unitil') {
        unitil_settings();
    } // Local Utility hidden field


    var utility = $('#input_13_36').val() ? $('#input_13_36').val() : '';

    if (utility) {

        if (utility.includes('Eversource West')) {
            eversource_west_settings();
        }

        if (utility.includes('Eversource East')) {
            eversource_east_settings();
        }

        if (utility.includes('National Grid')) {
            national_grid_settings();
        }

        if (utility.includes('Unitil')) {
            unitil_settings();
        }
    } // Local Utility radio field


    $('input[type="radio"][name="input_32"]').change(function () {

        if (this.value.includes('Eversource West')) {
            eversource_west_settings();
        }

        if (this.value.includes('Eversource East')) {
            eversource_east_settings();
        }

        if (this.value.includes('National Grid')) {
            national_grid_settings();
        }

        if (this.value.includes('Unitil')) {
            unitil_settings();
        }
    });

    function eversource_west_settings() {
        console.log(formMessages['eversource'].introduction);
        $('#field_13_37 p:first-child').text(formMessages['eversource'].introduction);
        $('#gfield_description_13_23').text(formMessages['eversource'].account_number);
        $('#gfield_description_13_27').text(formMessages['eversource'].customer_name_key);
        $('#input_13_23_1').attr('maxlength', '11');
        $('#input_13_23_2').attr('maxlength', '11');

        $('#field_13_39 .gfield_required').show();

        if ($('#field_13_39 label').children().length === 0 ) {
            $('#field_13_39 label').append('<span class="gfield_required"><span class="gfield_required gfield_required_text">(Required)</span></span>');
        }
    }

    function eversource_east_settings() {
        console.log(formMessages['eversource'].introduction);
        $('#field_13_37 p:first-child').text(formMessages['eversource'].introduction);
        $('#gfield_description_13_23').text(formMessages['eversource'].account_number);
        $('#gfield_description_13_27').text(formMessages['eversource'].customer_name_key);
        $('#input_13_23_1').attr('maxlength', '11');
        $('#input_13_23_2').attr('maxlength', '11');


        console.log('east');

        $('#field_13_39 .gfield_required').show();

        if ($('#field_13_39 label').children().length === 0 ) {
            $('#field_13_39 label').append('<span class="gfield_required"><span class="gfield_required gfield_required_text">(Required)</span></span>');
        }

        //$('#field_13_39').removeClass('gfield_error');
       // $('#field_13_39 .validation_message').remove();
        //$('#field_13_39 .gfield_required').hide();
    }

    function national_grid_settings() {
        $('#field_13_37 p:first-child').text(formMessages['national_grid'].introduction);
        $('#gfield_description_13_23').text(formMessages['national_grid'].account_number);
        $('#gfield_description_13_27').text(formMessages['national_grid'].customer_name_key);
        $('#input_13_23_1').attr('maxlength', '10');
        $('#input_13_23_2').attr('maxlength', '10');
    }

    function unitil_settings() {
        $('#field_13_37 p:first-child').text(formMessages['unitil'].introduction);
        $('#gfield_description_13_23').text(formMessages['unitil'].account_number);
        $('#gfield_description_13_27').text(formMessages['unitil'].customer_name_key);
        $('#input_13_23_1').attr('maxlength', '10');
        $('#input_13_23_2').attr('maxlength', '10');
    }

    function hideProductSelection() {
        var rateCount = $('#input_13_26 input').length;

        if (rateCount == 1) {
            $('#field_13_26').addClass('hide-product-select');
        }
    }

    function convertNumberInput()
    {
        $(".changeToTextField").each(function () {
            // Store the current element and its attributes
            var $numberInput = $(this);
            var attributes = $numberInput.prop("attributes");
            var value = $numberInput.val();

            // Create a new input[type='text'] element
            var $textInput = $("<input type='text'>");

            // Copy all attributes from the number input to the text input
            $.each(attributes, function () {
                $textInput.attr(this.name, this.value);
            });

            // Set the value of the new input
            $textInput.val(value);

            // Replace the number input with the text input
            $numberInput.replaceWith($textInput);
        });
    }

});